module.exports = __webpack_public_path__ + "static/media/stripe.0a03a27c.svg";